import React from 'react';
import { ActionBase } from '../ActionBase';
import { Store } from '../Store';
import { copyObject } from 'common/copyObject';

export type ForgotPasswordData = { mailaddress: string };

export const initialForgotPasswordData: ForgotPasswordData = {
	mailaddress: '',
};

//////////////////////////////////////////////////
// SaveAction
//////////////////////////////////////////////////
// Action
class SaveAction extends ActionBase {
	forgotPasswordData: ForgotPasswordData;
}
// Action name
const SaveActionName = SaveAction.toString();

// Action generator
export const saveGenerator = async (dispatch: React.Dispatch<ActionBase>, forgotPasswordData: ForgotPasswordData) => {
	const action = {
		action: SaveActionName,
		forgotPasswordData,
	} as SaveAction;

	dispatch(action);
};

// Reducer
const saveReducer = (state: Store, action: ActionBase): Store => {
	const thisAction = action as SaveAction;
	const newState: Store = copyObject(state);
	newState.forgotPasswordData = thisAction.forgotPasswordData;
	return newState;
};

////////////////////////////////////////////////////////////////////////////////
// Reduce functions finder
////////////////////////////////////////////////////////////////////////////////
export const ForgotPasswordReduceFunction = (state: Store, action: ActionBase): Store => {
	switch (action.action) {
		case SaveActionName:
			return saveReducer(state, action);
	}
	return null;
};
